// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const ContactLookupWrapper = styled.div`
  display: -ms-grid;
  -ms-grid-columns: (auto 1em)[3] auto;
  -ms-grid-rows: auto 1em auto;

  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 1em;
  grid-template-areas:
    "contact-code contact-name company-name actions"
    "billcode frn email .";
  grid-template-columns: repeat(3, 1fr) auto;
  grid-template-rows: auto auto;
  align-items: flex-end;
  justify-content: start;
    
  > :not(.contact-lookup-actions) {
    max-width: 204px !important;
    width: 204px !important;
  }

  > .contact-code {
    grid-area: contact-code;
  }

  > .contact-name {
    grid-area: contact-name;
  }

  > .company-name {
    grid-area: company-name;
  }

  > .billcode {
    grid-area: billcode;
  }

  > .frn {
    grid-area: frn;
  }

  > .email {
    grid-area: email;
  }

  /* Keep search/clear next to Company Name and on the input baseline. */
  > .contact-lookup-actions {
    grid-area: actions;
    display: flex;
    align-items: center;
    align-self: flex-end;
    margin-bottom: .15em;

    > .contact-lookup-search {
      margin-right: .5em;
    }

    > .clear-button {
      width: 50px;
    }
  }
`
